import { render, staticRenderFns } from "./RatingDistributors.vue?vue&type=template&id=1959e0df&scoped=true"
import script from "./RatingDistributors.vue?vue&type=script&lang=js"
export * from "./RatingDistributors.vue?vue&type=script&lang=js"
import style0 from "./RatingDistributors.vue?vue&type=style&index=0&id=1959e0df&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1959e0df",
  null
  
)

export default component.exports